// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PriceList.yaml
// Generated: 2026-07-02T11:40:08.793Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePriceList, UpdatePriceList, PriceList } from '@/types/pricing/PriceList';

/**
 * PriceList Service
 * CRUD operations for PriceList via the ABP API.
 */
export const priceListService = new EntityService<PriceList, CreatePriceList, UpdatePriceList>(
  '/api/pricing/pricelist',
  'PriceList',
);
